import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import ItemSearchableInputCard, {
  ListItem,
} from "~business/Cards/ItemSearchableInputCard";
import type { FieldChangeEvent } from "~business/Cards/types";

import { getPolizas, getPoliza } from "../actions";
import {
  aCampoSiniestro,
  CampoSiniestro,
  OpcionSiniestro,
} from "../../../types";

const useStyles = makeStyles((theme: any) => ({
  root: {
    width: "100%",
  },
  body: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    paddingRight: 10,
    borderRadius: "5px",
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
    backgroundColor: theme.colours.white,
    margin: "2%",
    width: "100%",
  },
}));

interface SliceBusqueda {
  polizas: OpcionSiniestro[];
}

const useReduxSelector = () =>
  useSelector<any, SliceBusqueda>((state) => ({
    polizas: state.cargaSiniestroReducer.polizasFilter,
  }));

interface BusquedaCardProps {
  isLoading?: boolean;
}

const BusquedaCard = ({ isLoading }: BusquedaCardProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [busqueda, setBusqueda] = useState<CampoSiniestro>({
    value: "",
    valid: false,
    focus: false,
  });

  const { polizas } = useReduxSelector();

  let timer: ReturnType<typeof setTimeout> | undefined;

  const handleChangeBusqueda = (busqueda: FieldChangeEvent<string | null>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setBusqueda(aCampoSiniestro(busqueda));
    }, 200);
  };

  const handleClickBusqueda = () => {
    dispatch(
      getPolizas({
        skip: 0,
        take: 10,
        fechaDesde: null,
        fechaHasta: null,
        searchCriteria: busqueda.value,
        estado: "Vigente",
        negocio: "",
        soloParaRenovar: false,
        compania: "",
      })
    );
  };

  const handleChangePoliza = (poliza: ListItem) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (poliza.value) dispatch(getPoliza(poliza.value));
    }, 200);
  };

  return (
    <>
      <div className={classes.root}>
        <div className={classes.body}>
          <div className={classes.card}>
            <ItemSearchableInputCard
              id={"busquedaPoliza"}
              isLoading={isLoading}
              label={"Búsqueda de Póliza"}
              value={busqueda.value}
              onChange={handleChangeBusqueda}
              onChangeItem={handleChangePoliza}
              onClick={handleClickBusqueda}
              tooltipContent={"Buscar Póliza"}
              placeholder={"Buscar por DNI o Dominio"}
              items={polizas}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BusquedaCard;
